export default {
    menu: {
        title: 'Menu'
    },
    timePicker: {
        title: 'Select time',
        am: 'AM',
        pm: 'PM',
        cancel: 'Cancel',
        save: 'Done'
    },
    minside: {
        title: 'Welcome back, {0}'
    },
    errorDialog: {
        title: 'Something went wrong',
        close: 'Cancel',
        reload: 'Refresh page',
        subtitle: 'Try to refresh the page or restart the browser.'
    },
    phoneVerification: {
        recaptchaTokenMissing: 'Recaptcha token missing. Reload the page and try again.',
        tooManyRequests: 'Too many requests. Please try again later.',
        missingParams: 'Missing parameters. Please try again.',
        requestForPhoneVerificationDefaultError: 'An error occurred while requesting for phone confirmation code. Please try again later.',
        checkPhoneVerificationCodeDefaultError: 'An error occurred while verifying phone confirmation code. Please try again later.'
    }
};
